import React, { FC, ReactNode, useRef } from "react";
import classNames from "classnames";

import { Footer, Header, Sidebar } from "./DashboardLayout";
import { IntercomObserver, VideoAskObserver } from "../components/observers";
import { useInfiniteScroll } from "../hooks/useInfinityScroll";
import { isMobileMedia } from "../utils/media";

type Props = {
  children?: ReactNode;
  title?: ReactNode;
  action?: ReactNode;
  containerClassName?: string;
  onScrollReachedBottomHandler?: () => void;
  hideIntercomOnInit?: boolean;
};

const DashboardLayout: FC<Props> = ({
  children,
  title,
  action,
  containerClassName,
  onScrollReachedBottomHandler,
  hideIntercomOnInit = false,
}) => {
  const actionContainerRef = useRef<HTMLDivElement | null>(null);

  const scrollableDivRef = useInfiniteScroll(() => {
    onScrollReachedBottomHandler && onScrollReachedBottomHandler();
  });

  return (
    <div className="w-full flex flex-row bg-white h-screen">
      <Sidebar className="max-w-[244px] basis-[244px] hidden md:flex h-screen !p-6" />

      <div className="flex-1 basis md:px-16 w-screen flex flex-col mx-auto h-screen bg-white">
        <Header title={title} action={action} />

        <div
          className={classNames(
            "mt-0 mb-0 overflow-y-auto h-full p-4 md:pt-0 md:px-0",
            containerClassName
          )}
          ref={scrollableDivRef}
        >
          {children}
        </div>

        {!isMobileMedia() && <Footer />}

        {/* Mobile Only */}
        {action && (
          <div
            className="md:hidden fixed bottom-0 flex flex-col items-center w-full p-4 bg-white !z-[25]"
            ref={actionContainerRef}
          >
            {action}
          </div>
        )}
      </div>

      <IntercomObserver
        footer={actionContainerRef}
        hideOnCreate={hideIntercomOnInit}
      />

      <VideoAskObserver
        footer={actionContainerRef}
        hideOnCreate={hideIntercomOnInit}
      />
    </div>
  );
};

export default DashboardLayout;
